<template>
  <PlayerProfileCard :player="player" v-if="player" />
</template>

<script>
  import PlayerProfileCard from '@/components/PlayerProfileCard'
  import player from '@/mixins/player'

  export default {
    name: 'PlayerProfileEmbed',
    components: {
      PlayerProfileCard
    },
    mixins: [player]
  }
</script>
